var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    _vm._g(
      _vm._b(
        {
          ref: _vm.data.ref,
          class: [_vm.data.class, _vm.data.staticClass],
          style: [_vm.data.style, _vm.data.staticStyle],
          attrs: {
            version: "1.1",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        "svg",
        _vm.data.attrs,
        false
      ),
      _vm.listeners
    ),
    [
      _c("g", { attrs: { fill: "none" } }, [
        _c("path", {
          attrs: { d: "M0,0h24v24h-24Z", transform: "translate(0, -0.001)" }
        })
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            d:
              "M8,18h-6v-10h18v-3c0,-1.102 -0.897,-2 -2,-2h-1v-3h-2v5h-1v-2h-7v-3h-2v5h-1v-2h-2c-1.103,0 -2,0.897 -2,2v13c0,1.103 0.897,2 2,2h6v-2Z"
          }
        }),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            attrs: {
              d:
                "M7,14c-3.86,0 -7,-3.14 -7,-7c0,-3.86 3.14,-7 7,-7c3.86,0 7,3.14 7,7c0,3.86 -3.14,7 -7,7Zm0,-12c-2.757,0 -5,2.243 -5,5c0,2.757 2.243,5 5,5c2.757,0 5,-2.243 5,-5c0,-2.757 -2.243,-5 -5,-5Z",
              transform: "translate(10, 10)"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: { d: "M4,5h-4v-5h2v3h2Z", transform: "translate(16, 13)" }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }